// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SortAscendingOutlinedSvg from "@ant-design/icons-svg/es/asn/SortAscendingOutlined";
import AntdIcon from '../components/AntdIcon';

var SortAscendingOutlined = function SortAscendingOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SortAscendingOutlinedSvg
  }));
};

SortAscendingOutlined.displayName = 'SortAscendingOutlined';
export default React.forwardRef(SortAscendingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SortAscendingOutlined.js
// module id = 1851
// module chunks = 0